import React, { useState } from 'react';
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '../shadcn-ui/drawer';
import { Button } from '../shadcn-ui/button';
import { EndFermentationSchema } from '@/schema/process-lot-schema';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import FormField from '../FormField';
import { toast } from 'sonner';
import { endFermentation } from '@/network/api.service';
import { useNavigate } from 'react-router-dom';

const EndFermentationDrawer = ({
  open: controlledOpen,
  onOpenChange: controlledOnOpenChange,
  onClose,
  lotId,
  processStepId,
  onSuccess,
  disabled,
}) => {
  const [loading, setLoading] = useState(false);
  const [internalOpen, setInternalOpen] = useState(false);
  const navigate = useNavigate();
  // Use controlled open if provided, otherwise use internal state
  const open = controlledOpen !== undefined ? controlledOpen : internalOpen;
  const setOpen = controlledOnOpenChange || setInternalOpen;

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(EndFermentationSchema),
    defaultValues: {
      end_at: new Date(),
      output_weight_kg: '',
    },
  });
  const handleOpenChange = newOpen => {
    setOpen(newOpen);
    if (!newOpen && onClose) {
      onClose();
    }
    if (newOpen) {
      // Blur any focused elements in the background when drawer opens
      const activeElement = document.activeElement;
      if (activeElement && activeElement instanceof HTMLElement) {
        activeElement.blur();
      }
    }
  };

  const onSubmit = async data => {
    console.log(data);
    try {
      const { data: respData } = await endFermentation(lotId, processStepId, data);
      if (respData.success) {
        toast.success('Fermentation finished successfully.');
        handleOpenChange(false);
        onSuccess();
      }
      navigate(`/process/lot/${lotId}/step`);
    } catch (error) {
      console.log(error);

      toast.error(error.response?.data?.message);
    }
  };

  const handleAddClick = () => {
    if (onClose) {
      onClose();
    }
    setOpen(true);
  };

  return (
    <Drawer open={open} onOpenChange={handleOpenChange}>
      <DrawerTrigger asChild>
        <Button className="mt-2 w-full" onClick={handleAddClick} disabled={disabled}>
          End Fermentation
        </Button>
      </DrawerTrigger>

      <DrawerContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DrawerHeader className="text-left">
            <DrawerTitle className="p-1">End Fermentation</DrawerTitle>
            <DrawerDescription className="hidden"></DrawerDescription>
          </DrawerHeader>
          <div className="flex flex-col gap-3 px-5 pb-5">
            <FormField
              datetime
              label="Fermentation End Time"
              name="end_at"
              required
              control={control}
              disabled={loading}
              errors={errors}
            />
            <FormField
              label="Fermentation End Weight (kg)"
              name="output_weight_kg"
              required
              type="number"
              inputMode="decimal"
              step="0.01"
              placeholder="Enter weight"
              register={register}
              className="bg-[#FAFAFA]"
              disabled={loading}
              errors={errors}
            />
          </div>
          <DrawerFooter className={'flex flex-row justify-end gap-2 border-t'}>
            <Button variant="outline" onClick={() => handleOpenChange(false)} disabled={loading}>
              Cancel
            </Button>
            <Button type="submit" disabled={loading}>
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              {loading ? 'Finishing...' : 'Finish'}
            </Button>
          </DrawerFooter>
        </form>
      </DrawerContent>
    </Drawer>
  );
};

export default EndFermentationDrawer;
